<script lang="ts">
  import {clickOutside} from '@/utils/common';
  import {createEventDispatcher} from 'svelte';
  import type {PreviewImage} from '@/types/common';
  import tippy from 'tippy.js';

  export let item: PreviewImage;
  export let selected: PreviewImage;
  const dispatch = createEventDispatcher();
  let placeholder: Element;
  const isAdmin = window.uData && window.uData.is_admin;
  const loadImage = () => {
    if (placeholder) placeholder.remove();
    dispatch('image-load');
  };

  let devalueLevel = 0;

  const toggleFavorite = (item: PreviewImage) => {
    dispatch('set-favorite');
  };

  const toggleFeature = (item: PreviewImage) => {
    dispatch('feature-click');
  };

  let favoriteTooltip: HTMLElement;
  let unFavoriteTooltip: HTMLElement;

  $: {
    if (favoriteTooltip) {
      tippy(favoriteTooltip, {
        theme: 'light',
        content: `<div class="flex flex-col p-2 items-center justify-center">
                    <span class="inline-block align-middle font-light">Add to Favorites</span>
                </div>`,
        allowHTML: true,
        placement: 'right'
      });
    }
    if (unFavoriteTooltip) {
      tippy(unFavoriteTooltip, {
        theme: 'light',
        content: `<div class="flex flex-col p-2 items-center justify-center">
                    <span class="inline-block align-middle font-light">Remove from Favorites</span>
                </div>`,
        allowHTML: true,
        placement: 'right'
      });
    }
  }
</script>

<div
  class="image-item relative flex w-1/4 cursor-pointer flex-col gap-2 text-ellipsis p-2 {isAdmin
    ? 'hover:bg-gray-200'
    : ''}"
>
  <div
    class="relative h-full w-full rounded-xl {selected.id === item.id
      ? 'shadow-lg outline outline-4 outline-primary'
      : ''}"
    data-template-id={item.id}
  >
    <img
      alt={item.title}
      src={item.src}
      loading="lazy"
      on:load={loadImage}
      on:click={() => dispatch('image-click')}
      on:keydown={() => dispatch('image-click')}
      data-id={item.id}
      id="image-item-{item.id}"
      use:clickOutside
      class="relative z-10 h-full w-full rounded-xl"
    />
    <button
      on:click={() => toggleFavorite(item)}
      id="toggle_favorite"
      class="absolute right-2 top-2 z-20 rounded-full border-0 p-2"
    >
      {#if item.isFavorite == false}
        <span bind:this={favoriteTooltip}>
          <i class="fa-regular fa-star text-2xl text-[#FABE24]" />
        </span>
      {/if}
      {#if item.isFavorite == true}
        <span bind:this={unFavoriteTooltip}>
          <i class="fa-solid fa-star text-2xl text-[#FABE24]" />
        </span>
      {/if}
    </button>
    {#if isAdmin}
      <details class="absolute bottom-2 right-2 z-30 mr-2">
        <summary>
          <i class="fa-solid fa-ellipsis-vertical text-2xl text-[#FABE24]"></i>
        </summary>
        <div class="absolute grid justify-stretch rounded-md bg-white p-6 shadow-sm" role="group">
          <div class="grid grid-flow-col gap-1">
            <button
              on:click={() => dispatch('admin-click')}
              class="rounded-md border-2 border-gray-700 px-4 py-1 text-sm font-medium text-gray-700 hover:bg-red-400 hover:text-white"
            >
              Delete Template
            </button>
            <button
              on:click={() => toggleFeature(item)}
              class="text rounded-md border-2 border-gray-700 px-4 py-1 text-sm font-medium hover:bg-red-400 hover:text-white"
            >
              {#if item.isFeatured == false}
                Feature Template
              {/if}
              {#if item.isFeatured == true}
                Remove Feature
              {/if}
            </button>
          </div>
          <div class="flex gap-1">
            <button on:click={() => dispatch('devalue-down')}>
              <i class="fa-solid fa-minus"></i>
            </button>
            <input type="number" value={item.devalueLevel} />
            <button on:click={() => dispatch('devalue-up')}>
              <i class="fa-solid fa-plus"></i>
            </button>
          </div>
        </div>
      </details>
    {/if}
  </div>
</div>
